module.exports = __webpack_public_path__ + "img/empty_mailbox_color.7b85c676.svg";